<template>
<div class="template">
  <div class="  glass text-center">

              <div class="title">
                  <h4>အောက်ဆီဂျင်</h4>
                  <h5> ဘယ်လောက်ကျန်သေးလဲ</h5>
              </div>

                <div class="col-md-4 mx-auto d-block text-center form">
                    <form @submit.prevent = "oxyResult">

                      <div class="mb-2 p-2">
                          <label for="oxymeter" class="mb-1"> pressure ထည့်ရန် (psi) </label>
                        <input type="number" class="form-control text-center" v-model="oxyMeter" id="oxymeter" placeholder="1200 psi" />
                      </div>


                  <div class="mb-2 p-2">
                      <label for="tankSelect" class="mb-1"> ဘူးအရွယ်အစားရွေးရန် </label>
                      <select class="form-select form-select-md text-center" aria-label="Default select example"  v-model="tankSelect"> 

                                  <option v-for="option in options" :key ='option.id' :value="option.value" >
                                         {{ option.text}}
                                    </option>
                        
                      </select>
                  </div>



                <div class="mb-2 p-2">
                    <label for="flowSelect" class="mb-1"> အောက်ဆီဂျင် Flow Rate  ရွေးရန်</label>
                          <select class="form-select form-select-md" aria-label="Default select example"  v-model="flowSelect">
                            <option v-for="flowOption in flowOptions" :key='flowOption.id' :value="flowOption.value">
                                {{ flowOption.text }}
                            </option>
                    </select>
                </div>

                <button class="btn btn-primary text-center mt-1" id="oxyClick"> တွက်မယ် </button>
              </form>
      </div>

      <div class="answer">
            <h3 >{{ oxyData }} </h3>
      </div>
    </div>
</div>
</template>
<script>
export default {
  name: "Home",

  data() {
    return {
      tankSelect : '0.16',
      options : [
        { text:'D Tank ( အိုးအသေး )' , value : '0.16'},
        {text:'E Tank ( အိုးအလတ် )' , value:'0.28'},
        {text: 'M Tank ( အိုးအကြီး )'  , value: '1.56 '}

      ],

      flowSelect : '1' ,
      flowOptions : [
        {text:'1' , value: '1'},
        {text:'2' , value: '2'},
        { text:'3' , value:'3'},
        { text: '4' , value: '4'},
        {text:'5' , value: '5'},
        {text:'6' , value: '6'},
        { text:'7' , value:'7'},
        { text: '8' , value: '8'},
         { text:'9' , value:'9'},
        { text: '10' , value: '10'},

      ],

      oxyMeter : '' ,
      oxyData : '',


     }
  },

  methods: {
      oxyResult () 
      {
          let oxyData1 = (this.oxyMeter - 200) * this.tankSelect ;
          let oxyData2 =  oxyData1/this.flowSelect ;
          let oxyData3 = Math.round(oxyData2) ;
          
          this.oxyData = " မိနစ် " + oxyData3 + " ကျန်ပါသည်"  ;
      }
  }
}

</script>
 



<style>
      

        .template {
          min-height: 100vh;
          background:linear-gradient(to right top, #85ebd8, #e2e8e9);
          display: flex;
          align-items: center;
          justify-content: center;
           overflow: hidden;
          
        }

        .form {
          margin-top: 30px;
        }

        

      
</style>